import graph from './graph';
import Attachments from './Attachments';
import Users from './Users';
import Products from './Products';
import BookmarkRoundedIcon from '@mui/icons-material/BookmarkRounded';

import jMoment from 'moment-jalaali';
import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { isEmptyObject } from 'helpers/formatObject';
import { useLazyQuery, useMutation } from '@apollo/client';
import { Avatar, Button, Box, Card, CardHeader, Stack, Tab, Typography, CircularProgress } from '@mui/material';
import { NewDialog, CustomList, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';
import Reject from './Reject';
import UserStatistics from './UserStatistics';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { addCommas, digitsFaToEn } from '@persian-tools/persian-tools';
import Coupons from './Coupons';

export default function ReadyCoupon({ id, title, refetch }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [done, { loading: updating }] = useMutation(graph.done.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const [step, setStep] = useState('1');

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids: id,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data[0];
        const { status, coupon } = res;
        if (res) {
          setFormData({
            status,
            coupon,
          });
        }
      }
    } catch (error) {}
  };

  const onSubmit = async () => {
    try {
      const { data, errors } = await done({
        context: {
          serviceName: graph.done.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          id,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.done.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  // const establishment = formData?.coupon?.media.find((x) => x.collection_name === 'establishment');
  // const advertisement = formData?.coupon?.media.find((x) => x.collection_name === 'advertisement');

  return (
    <>
      <Button size="small" color="info" onClick={onOpen} variant="contained">
        بررسی
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          {loading ? (
            <Stack rowGap={2} height="100%" alignItems="center" justifyContent="center">
              <CircularProgress size={20} color="inherit" />
              <Typography align="center" variant="caption" color="text.disabled">
                در حال بارگذاری...
              </Typography>
            </Stack>
          ) : (
            <Stack p={1} rowGap={1} bgcolor="background.paper">
              {/* <Stack direction="row" columnGap={1}>
                <Attachments media={establishment} label="آگهی تاسیس" />
                <Attachments media={advertisement} label="آگهی تغییرات" />
              </Stack> */}

              {/* <CustomList
                data={{
                  title: 'عنوان بن',
                  value: formData?.coupon?.title,
                  children: [
                    {
                      title: 'مبلغ بن برای هر نفر',
                      value: addCommas(Number(formData?.coupon?.amount)),
                      unit: 'تومان',
                    },
                    {
                      title: 'فروشگاه',
                      value: formData?.coupon?.shop?.title,
                    },
                    {
                      title: 'تاریخ شروع',
                      value: formData?.coupon?.start_date
                        ? jMoment(formData?.coupon?.start_date).format('jYYYY/jMM/jDD')
                        : '-',
                    },
                    {
                      title: 'تاریخ پایان',
                      value: formData?.coupon?.end_date
                        ? jMoment(formData?.coupon?.end_date).format('jYYYY/jMM/jDD')
                        : '-',
                    },
                  ],
                }}
              />
               */}
              <Model {...formData?.coupon} step={step} setStep={setStep} />
              <UserStatistics id={formData?.coupon?.id} />
            </Stack>
          )}
        </NewDialogContent>
        <NewDialogActions>
          {(formData?.status === 'TODO' || formData?.status === 'DOING') && (
            <>
              <Reject id={id} refetch={refetch} />

              <Button
                autoFocus
                size="medium"
                color="success"
                variant="contained"
                sx={{ minWidth: 80 }}
                disabled={updating}
                onClick={onSubmit}
              >
                {updating ? <CircularProgress color="inherit" size={24} /> : 'قبول درخواست'}
              </Button>
            </>
          )}
          <Coupons id={formData?.coupon?.id} />
        </NewDialogActions>
      </NewDialog>
    </>
  );
}

function Model({
  id,
  shop,
  type,
  step,
  title,
  users,
  status,
  amount,
  setStep,
  end_date,
  is_active,
  start_date,
  products_shop,
  product_categories,
}) {
  return (
    <>
      <Box>
        <Card>
          <CardHeader
            sx={{ p: 1 }}
            avatar={
              <Avatar sx={{ height: 28, width: 28, fontSize: 18, bgcolor: 'action.selected' }}>
                <BookmarkRoundedIcon fontSize="inherit" color="primary" />
              </Avatar>
            }
            title={<Typography variant="subtitle2">{title}</Typography>}
            subheader={
              <Typography variant="caption" color="textDisabled">{`هر نفر ${addCommas(
                Number(amount)
              )} تومان`}</Typography>
            }
            action={
              <Stack rowGap={1}>
                <Typography
                  px={0.5}
                  borderRadius={0.5}
                  variant="caption"
                  color="warning.darker"
                  bgcolor="warning.lighter"
                >{`فروشگاه ${shop?.title}`}</Typography>
                <Typography variant="caption" px={0.5} color="textDisabled">
                  انقضا:
                  <Typography component="span" variant="caption" letterSpacing={0.5}>
                    {digitsFaToEn(jMoment(end_date).format('jYYYY/jMM/jDD'))}
                  </Typography>
                </Typography>
              </Stack>
            }
          />
        </Card>
      </Box>
      <UsersAndProducs
        step={step}
        type={type}
        users={users}
        setStep={setStep}
        products={products_shop || []}
        categories={product_categories || []}
      />
    </>
  );
}

function UsersAndProducs({ type, products, categories, users, step, setStep }) {
  const handleChange = (event, newValue) => {
    setStep(newValue);
  };
  return (
    <TabContext value={step}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList variant="fullWidth" onChange={handleChange} aria-label="owners">
          <Tab label="محصولات" value="1" />
          <Tab label="کاربران" value="2" />
        </TabList>
      </Box>
      <TabPanel sx={{ px: 1, py: 2 }} value="1">
        <Products type={type} products={products} categories={categories} />
      </TabPanel>
      <TabPanel sx={{ px: 1, py: 2 }} value="2">
        <Users type={type} users={users} />
      </TabPanel>
    </TabContext>
  );
}